import { useEffect, useState, useCallback } from "react";
import { api, apiErr } from "@/lib/api";

// Enkel datahämtning med laddnings-/felstatus.
export function useApi(path, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    if (!path) { setData(null); setLoading(false); return; }
    setLoading(true);
    api.get(path)
      .then((r) => { setData(r.data); setError(null); })
      .catch((e) => { setError(apiErr(e)); })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  useEffect(() => { reload(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, ...deps]);
  return { data, loading, error, reload, setData };
}
